module.exports = "import { SystemHeader, SystemTitle } from \"../../../lib\";\nimport React from \"react\";\n\nexport default () =>\n  (<SystemHeader>\n    <SystemTitle title=\"hello world\"/>\n  </SystemHeader>);\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./src/SystemHeader/SystemHeader/demo/withLabel.js
// module id = 136
// module chunks = 0